// extracted by mini-css-extract-plugin
export default {"primary_btn":"style_primary_btn__XZO2N","secondary_btn":"style_secondary_btn__tX7Tt","popup":"style_popup__rg7KS","title":"style_title__id+GP"};